module.exports = __webpack_public_path__ + "static/media/qiwi.5646e75b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/qiwi.svg
// module id = 394
// module chunks = 7